module.exports = __webpack_public_path__ + "static/media/3_col_8.84f4b9df.jpg";